import getCookie from './get-cookie';

function getCookieMiddleware(app) {
  return (_, { headers }) => {
    if (headers && headers.authorization) return { headers };
    const cookie = getCookie(app);
    if (!cookie) return { headers };

    return {
      headers: {
        ...headers,
        authorization: `Bearer ${cookie}`
      }
    };
  };
}
export default getCookieMiddleware;
